import { useZustand } from "../zustand/store";
import { useParams } from "react-router-dom";
import { retrieveAllArt } from "../firebase";
import PageNotFound from "./PageNotFound";
import MadeByOlaBanner from "../components/BottomBanner/MadeByOlaBanner";
import ProjectCard from "../components/Art/subComponents/ProjectCard";
import Navigation from "../components/Head/subComponents/Navigation";
import ScrollToTop from "../components/general/ScrollToTop";

let artForThisSection: any = "";

function ArtSection() {
  let { slug } = useParams();

  const { artProjects, setArtProjects } = useZustand();

  //IMPORTANT
  artForThisSection = "";

  if (artProjects.length === 0) {
    console.log("trying to retrieve");
    retrieveAllArt((val: any) => setArtProjects(val));
  }

  if (artProjects.length !== 0) {
    let data;
    data = artProjects.filter((i: any) => {
      return i.data.section === slug;
    });

    if (data.length === 0) {
      //incase of wrong artSection slug
      artForThisSection = null;
    } else {
      console.log(data);
      //sort in descending order based on date
      artForThisSection = data.sort(
        (artA: any, artB: any) => artB.data.timeStamp - artA.data.timeStamp
      );
    }
  }

  return (
    <div>
      <ScrollToTop />
      <div className="sticky top-0 w-full bg-white/60 backdrop-blur-sm">
        <Navigation />
      </div>
      <div className="px-3 md:px-10 py-2 w-full min-h-screen flex flex-col justify-start text-black font-boska">
        {artForThisSection === null ? (
          <PageNotFound />
        ) : artForThisSection === "" ? (
          <h1 className="text-3xl md:text-5xl font-black text-black font-boska text-center items-center">
            Loading Art!
          </h1>
        ) : (
          <div className="flex flex-col justify-start items-start">
            <h1 className="text-3xl md:text-5xl font-black">{slug}:</h1>
            <p className="text-xl md:text-3xl font-light">
              (Click On Image For More Info!)
            </p>
            <div className="flex flex-col md:grid grid-cols-3 justify-start md:justify-center items-center gap-10 pt-10">
              {artForThisSection.map((i: any, index: any) => {
                return <ProjectCard data={i.data} key={index} />;
              })}
            </div>
            <div className="flex justify-center pt-4">
              <MadeByOlaBanner />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ArtSection;
